export default __webpack_public_path__ + "static/media/item-sourcing-banner.775ff6cb.png";